import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/forex/[pair]/ForexDetailClient.tsx");
